import * as React from 'react'
import createSvgIcon from '../createSvgIcon'

export default createSvgIcon(
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g id='icon' clipPath='url(#clip0_60_2082)'>
      <path
        id='Vector'
        d='M12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75Z'
        stroke='currentColor'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        id='Vector_2'
        d='M3.88449 16.6959C3.47009 15.9821 3.15261 15.2163 2.94043 14.4187L4.51355 12.4499C4.49574 12.149 4.49574 11.8472 4.51355 11.5462L2.94137 9.57744C3.15319 8.7797 3.47002 8.01363 3.88355 7.29932L6.38762 7.01807C6.58758 6.79278 6.80077 6.57959 7.02605 6.37963L7.3073 3.8765C8.02059 3.46494 8.78541 3.14999 9.58168 2.93994L11.5504 4.51307C11.8514 4.49525 12.1532 4.49525 12.4542 4.51307L14.4229 2.94088C15.2207 3.1527 15.9867 3.46953 16.7011 3.88307L16.9823 6.38713C17.2076 6.58709 17.4208 6.80028 17.6207 7.02557L20.1239 7.30682C20.5383 8.0206 20.8557 8.78639 21.0679 9.584L19.4948 11.5528C19.5126 11.8537 19.5126 12.1555 19.4948 12.4565L21.067 14.4253C20.8567 15.2228 20.5414 15.9888 20.1295 16.7034L17.6254 16.9846C17.4255 17.2099 17.2123 17.4231 16.987 17.6231L16.7057 20.1262C15.992 20.5406 15.2262 20.8581 14.4286 21.0703L12.4598 19.4971C12.1588 19.5149 11.857 19.5149 11.5561 19.4971L9.5873 21.0693C8.7898 20.859 8.02374 20.5437 7.30918 20.1318L7.02793 17.6278C6.80264 17.4278 6.58945 17.2146 6.38949 16.9893L3.88449 16.6959Z'
        stroke='currentColor'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
    <defs>
      <clipPath id='clip0_60_2082'>
        <rect width='24' height='24' fill='currentColor' />
      </clipPath>
    </defs>
  </svg>,
  'Settings'
)
